import { useEffect, useState } from "react";
import TopEntryBar from "@/pages/home/components/TopEntryBar";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import LatestFeed from "@/pages/home/components/LatestFeed";
import FeaturedGrid from "@/pages/home/components/FeaturedGrid";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import EventTimeline from "@/pages/home/components/EventTimeline";
import HotRanking from "@/pages/home/components/HotRanking";
import InfluencerDirectory from "@/pages/home/components/InfluencerDirectory";
import CommunityThreads from "@/pages/home/components/CommunityThreads";
import DownloadCta from "@/pages/home/components/DownloadCta";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 900);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <TopEntryBar />
      <Navbar />
      <main>
        <Hero />
        <LatestFeed />
        <FeaturedGrid />
        <CategoryEntries />
        <EventTimeline />
        <HotRanking />
        <InfluencerDirectory />
        <CommunityThreads />
        <DownloadCta />
      </main>
      <SiteFooter />

      <button
        type="button"
        aria-label="回到顶部"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-all duration-300 hover:bg-primary-600 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </div>
  );
}